import React from 'react';
import { Button, Heading, FormGroup } from 'arag-ui-lib';
import _ from 'lodash';
import { formGroupVariants, secondaryVariantStyle } from '../helpers/formGroupVariants';

const PreviousApplicationUpdate = (props) => {

    const { PreviousUpdate, Date, answers } = props;

    return (
       <div className={'row print'}>
           <div className="col-sm-12">
               <div className="row col-sm-12">
                    <Heading variant="h2" title={`Policy Update ${Date}`} headingTestId={'policy-previous-update-header'}/>
               </div>
               <form className="form-horizontal">
                {
                    _.sortBy(PreviousUpdate.policyUpdateAnswersDtos, ['sortOrder']).map((item, index) => {
                        return (
                            <FormGroup 
                                id={item.questionId}
                                key={item.questionId}
                                labelSize={'col-sm-5'}
                                inputSize={'col-sm-7'}
                                label={item.questionName}
                                variant={item.inputType}
                                inputProps={{
                                    label: answers[item.questionMachineName],
                                }}
                                requiredStyle={secondaryVariantStyle}
                                formGroupTestId={`policy-previous-update-${item.questionMachineName}`}
                            />
                        )
                    })
                }
                {
                    PreviousUpdate.attachment ?
                        <FormGroup 
                            id={PreviousUpdate.attachment.id}
                            key={PreviousUpdate.attachment.id}
                            labelSize={'col-sm-5'}
                            inputSize={'col-sm-7'}
                            label={'Attachment'}
                            variant={formGroupVariants.plain}
                            inputProps={{
                                label: PreviousUpdate.attachment.name + (PreviousUpdate.attachment.tags ? ' - ' + PreviousUpdate.attachment.tags : '')
                            }}
                            requiredStyle={secondaryVariantStyle}
                            formGroupTestId={`policy-previous-update-attachment`}
                        /> : null
                }
                </form>
                <Button
                    onClick={window.print}
                    variant={'tertiary'}
                    label={'Print'}
                    buttonTestId={'policy-previous-update-print'}
                />
           </div>
       </div>
    )
};

export default PreviousApplicationUpdate;